export default __webpack_public_path__ + "static/media/BasketballCourt3.db31ab85.png";